/*
 *  LiveButton.jsx
 *
 *
 *
 */
//==============================================================================
// External dep.
//==============================================================================
import React, { useCallback, useMemo, useState } from "react";
import LoadingIndicator from "react-loading-indicator";
import { useTranslation } from "react-i18next";
import { withLDConsumer } from "launchdarkly-react-client-sdk";
import { CustomerSucessController, Button as BtnPrimary } from "@talentbait/shared-components";

import { STATUS_WITH_SET_LIVE } from "../../../PagesUser/SelfServiceCampaignCreation/Previews/constants";
import Actions from "../../../Actions";
import logger from "../../../utils/LoggerFrontend";

const LiveButton = ({
  status,
  setStatus,
  campaignId,
  adsetId,
  setShowStartingDatePanel,
  startDate,
  source,
  jobUpdatesUrl,
  campaignManager = "",
  userProfile: { userName, userId, userRole },
  flags,
  organization
}) => {
  const { t } = useTranslation();
  const [isSettingCampaignLive, setIsSettingCampaignLive] = useState(false);

  const setCampaignLive = useCallback(() => {
    logger.log("LiveButton:setCampaignLive", "called", {
      campaignId,
      displayName: userName,
      userName,
      userId,
      userRole,
      startDate,
      source,
      jobUpdatesUrl,
      isSettingCampaignLive
    });

    if (isSettingCampaignLive) {
      return;
    }

    const meta = {
      userProfile: { userName, userId, userRole },
      campaignManager,
      commentMeta: {
        eventName: "preview",
        eventStatus: "approved",
        campaignManager,
        initiator: "system",
        type: "ad-preview-client"
      },
      source
    };
    setIsSettingCampaignLive(true);

    const ref = Actions.setCampaignLive.completed.listen((result) => {
      logger.log("LiveButton:setCampaignLive", "successfully set campaign live", {
        campaignId,
        displayName: userName,
        result
      });
      Actions.addNotification(t("Campaign was successfully released"));
      setIsSettingCampaignLive(false);
      setStatus("ACTIVE");
      setShowStartingDatePanel(false);
      CustomerSucessController.send("preview:startCampaign", {
        campaignId
      });
      ref();
    });

    const refFailed = Actions.setCampaignLive.failed.listen((error) => {
      logger.log("error:LiveButton:setCampaignLive", "unable to set campaigns live", {
        error,
        campaignId,
        displayName: userName
      });
      setIsSettingCampaignLive(false);
      Actions.addNotification(t("Campaign was not released (2)"), "error");
      refFailed();
    });

    Actions.setCampaignLive(
      campaignId,
      adsetId,
      null,
      meta,
      false,
      !(organization && organization.isAgency)
    );
  }, [
    userId,
    userRole,
    campaignId,
    userName,
    setStatus,
    setShowStartingDatePanel,
    startDate,
    source,
    jobUpdatesUrl,
    campaignManager,
    adsetId,
    isSettingCampaignLive,
    organization,
    t
  ]);

  const showCTAButton = useMemo(() => STATUS_WITH_SET_LIVE.includes(status), [status]);

  if (!showCTAButton) {
    return null;
  }

  return (
    <BtnPrimary
      type="success"
      size="veryLarge"
      mb="20px"
      width="100%"
      onClick={setCampaignLive}
      disabled={isSettingCampaignLive}
    >
      {isSettingCampaignLive ? (
        <LoadingIndicator
          color={{
            red: 255,
            green: 255,
            blue: 255,
            alpha: 1
          }}
        />
      ) : (
        t("Approve campaign & start now")
      )}
    </BtnPrimary>
  );
};

export default withLDConsumer()(LiveButton);
